import { createDataMapper } from '@common/utils/query/dataMappers';
import { BackendProduction, Production } from './types';

const mapBackendProductionToFrontendProduction = (
    backendProduction: BackendProduction,
): Production => {
    return {
        id: backendProduction.id,
        name: backendProduction.name,
        activeStatus: backendProduction.activeStatus,
        avatar: backendProduction.avatar || '',
        hasAvatar: backendProduction.hasAvatar,
    };
};

export const transformProduction = createDataMapper<
    BackendProduction,
    Production
>(mapBackendProductionToFrontendProduction, true);
